module.exports = __webpack_public_path__ + "static/media/google-drive.f31dc716.svg";